import { Box, Switch, Typography } from "@mui/material";
import React, { Dispatch } from "react";

interface JobsMatrixProps {
	newAddOnSettings: any; // TODO: Define type
	setNewAddOnSettings: Dispatch<any>;
}

const JobsMatrix: React.FC<JobsMatrixProps> = ({
	newAddOnSettings,
	setNewAddOnSettings,
}) => {
	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				marginTop: "32px",
				padding: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Jobs Matrix
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Enable Supervisors to view and manage job assignments in a matrix view.
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Switch
						checked={newAddOnSettings.jobsMatrixEnabled ?? false}
						onChange={(e) => {
							setNewAddOnSettings((pre: any) => ({
								...pre,
								jobsMatrixEnabled: e.target.checked,
							}));
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default JobsMatrix;
